export const AUTH0_ORGANIZATION_METADATA_VALUE_MAX_LENGTH = 255;
export const BRAND_ASSET_BUCKET_DIRECTORY = "client_logos";

type SanitizeBrandAssetFileNameArgs = {
  auth0Name: string;
  originalFileName: string;
  publicBucketUrl: string;
  maxUrlLength?: number;
};

const DIMENSION_PATTERN = /(\d)\s+x\s+(\d)/gi;
const UNSAFE_STEM_CHARS = /[^A-Za-z0-9._-]+/g;

function splitExtension(fileName: string): { stem: string; ext: string } {
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot <= 0 || lastDot === fileName.length - 1) {
    return { stem: fileName, ext: "" };
  }
  return { stem: fileName.slice(0, lastDot), ext: fileName.slice(lastDot) };
}

function slugifyStem(stem: string): string {
  return stem
    .replace(DIMENSION_PATTERN, "$1x$2")
    .trim()
    .replace(/\s+/g, "-")
    .replace(UNSAFE_STEM_CHARS, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-+|-+$/g, "");
}

function constructedUrlLength(
  publicBucketUrl: string,
  auth0Name: string,
  fileName: string
): number {
  const prefix = publicBucketUrl
    ? `${publicBucketUrl}/${BRAND_ASSET_BUCKET_DIRECTORY}/${auth0Name}/`
    : `${BRAND_ASSET_BUCKET_DIRECTORY}/${auth0Name}/`;
  return prefix.length + fileName.length;
}

export function sanitizeBrandAssetFileName({
  auth0Name,
  originalFileName,
  publicBucketUrl,
  maxUrlLength = AUTH0_ORGANIZATION_METADATA_VALUE_MAX_LENGTH,
}: SanitizeBrandAssetFileNameArgs): string {
  const { stem: rawStem, ext } = splitExtension(originalFileName);
  let stem = slugifyStem(rawStem) || "logo";
  let dest = `${stem}${ext}`;

  while (
    dest &&
    constructedUrlLength(publicBucketUrl, auth0Name, dest) > maxUrlLength
  ) {
    if (stem.length <= 1) {
      break;
    }
    stem = stem.slice(0, -1).replace(/-+$/g, "");
    dest = `${stem}${ext}`;
  }

  return `${auth0Name}/${dest}`;
}
